export default "__VITE_ASSET__mfkPHfNT__"